import { render, staticRenderFns } from "./type4.vue?vue&type=template&id=aa7d1f18&scoped=true&"
import script from "./type4.vue?vue&type=script&lang=js&"
export * from "./type4.vue?vue&type=script&lang=js&"
import style0 from "./type4.vue?vue&type=style&index=0&id=aa7d1f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7d1f18",
  null
  
)

export default component.exports